import { HttpClient, URL_API } from "../../network";

export type TTopUtilizationRatingParams = {
  rating_type?: "daily" | "weekly" | "monthly";
};

class Evse extends HttpClient {
  getAll = async (params: TParams) => {
    const data = await this.instance.get<IResponse<Array<IEvse>>>(
      URL_API.EVSES.GET_LIST,
      {
        params,
      }
    );
    return data;
  };
  getDetail = async (id: string) => {
    const data = await this.instance.get<any>(
      URL_API.EVSES.GET_LIST + `/${id}`
    );
    return data;
  };

  update = async (id: string, params: Object) => {
    const data = await this.instance.put<any>(
      URL_API.EVSES.GET_LIST + `/${id}`,
      params
    );
    return data;
  };

  listUser = async (params?: Object) => {
    const data = await this.instance.get<any>(
      URL_API.EVSES.GET_LIST + `/restricted-users`,
      { params }
    );
    return data;
  };

  addRestrictedUser = async (dto: {
    user_ids: string[];
    evse_ids: string[];
  }) => {
    const data = await this.instance.post(
      URL_API.EVSES.GET_LIST + `/add-restricted-user`,
      dto
    );
    return data;
  };

  RemoveRestrictedUser = async (dto: {
    user_ids: string[];
    evse_ids: string[];
  }) => {
    const data = await this.instance.post(
      URL_API.EVSES.GET_LIST + `/remove-restricted-user`,
      dto
    );
    return data;
  };

  UpdateRestrictedUser = async (dto: {
    user_id: string;
    evse_ids: string[];
  }) => {
    const data = await this.instance.post(
      URL_API.EVSES.GET_LIST + `/update-restricted-user`,
      dto
    );
    return data;
  };

  OnOffSubscriptionPlans = async (dto: {
    evse_id: string;
    subscription_price_enabled: boolean;
    enable_subscription_plans?: string[];
  }) => {
    const { evse_id, ...parm } = dto;
    const data = await this.instance.post(
      URL_API.EVSES.GET_LIST + `/${evse_id}/subscription-plans`,
      parm
    );
    return data;
  };

  OnOffReservation = async (dto: {
    evse_id: string;
    reservation_enabled: boolean;
  }) => {
    const data = await this.instance.put(
      URL_API.EVSES.GET_LIST + `/${dto.evse_id}`,
      dto
    );
    return data;
  };

  topUtilizationRating = async (params: TTopUtilizationRatingParams) => {
    const data = await this.instance.get<
      IResponse<Array<ITopUtilizationRatingEvse>>
    >(
      URL_API.EVSES.TOP_UTILIZATION_RATING,
      {
        params,
      }
    );
    return data;
  };

  getStatic = async (type: string) => {
    const data = await this.instance.get<
      IResponse<{
        countDc: number;
        countAc: number;
        available: number;
        unavailable: number;
        charging: number;
        faulted: number;
        total: number;
      }>
    >("/v1/evses/statistics", {
      params: { type },
    });
    return data;
  };

  sync = async (evseId: string) => {
    const data = await this.instance.post(`${URL_API.EVSES.SYNC}/${evseId}`);
    return data;
  };

  ampecoSyncEvse = async (ampecoChargepointId: string) => {
    const data = await this.instance.post(
      URL_API.CHARGE_POINTS.AMPECO_SYNC_EVSE,
      {
        ampeco_chargepoint_id: ampecoChargepointId,
      }
    );
    return data;
  };

  syncAllEvses = async () => {
    const data = await this.instance.post(URL_API.EVSES.SYNC_ALL);
    return data;
  };

  exportPricing = async (params: Object) => {
    const data = await this.instance.get(
      URL_API.EVSES.GET_LIST + "/export-pricing",
      {
        params,
        responseType: "blob",
      }
    );
    return data;
  };

  importPricing = async (formData: FormData) => {
    const data = await this.instance.post(
      URL_API.EVSES.GET_LIST + "/import-pricing",
      formData,
      {
        headers: {
          accept: "application/json",
          "Content-Type": "multipart/form-data; ",
        },
      }
    );
    return data;
  };
}
export const EvseService = new Evse();
